export default "__VITE_ASSET__CaQLgUHR__"